const ACCESS_TOKEN = 'access_token'
const SELECTED_AFFILIATE_ID = 'selected_affiliate_id'

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN)
}

export function setAccessToken(value: string) {
  return localStorage.setItem(ACCESS_TOKEN, value)
}

export function removeAccessToken() {
  return localStorage.removeItem(ACCESS_TOKEN)
}

export function getSelectedAffiliateId() {
  return Number(localStorage.getItem(SELECTED_AFFILIATE_ID))
}

export function setSelectedAffiliateId(affiliateId: number) {
  localStorage.setItem(SELECTED_AFFILIATE_ID, String(affiliateId))
}
